export default __webpack_public_path__ + "0975ff94192363e6bb8988370e2b7465.png";